import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { tokens } from '@everfi/design-system';
import { dataAttribsForEl } from '../../../utils/dataAttribsForEl.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Image } from '../../../core/components/Image/component.js';
var CardMediaBox = function CardMediaBox(props) {
  var _props$chakra = props.chakra,
    chakra = _props$chakra === void 0 ? 'on' : _props$chakra,
    className = props.className,
    hasLabel = props.hasLabel,
    mediaAspectRatio = props.mediaAspectRatio,
    _props$mediaBackgroun = props.mediaBackground,
    mediaBackground = _props$mediaBackgroun === void 0 ? 'white' : _props$mediaBackgroun,
    mediaContent = props.mediaContent,
    _props$mediaDataAttri = props.mediaDataAttributes,
    _props$mediaDataAttri2 = _props$mediaDataAttri === void 0 ? {} : _props$mediaDataAttri,
    _props$mediaDataAttri3 = _props$mediaDataAttri2.context,
    context = _props$mediaDataAttri3 === void 0 ? {} : _props$mediaDataAttri3,
    optionalAttributes = _props$mediaDataAttri2.optionalAttributes,
    _props$mediaPosition = props.mediaPosition,
    mediaPosition = _props$mediaPosition === void 0 ? 'left' : _props$mediaPosition,
    _props$mediaSize = props.mediaSize,
    mediaSize = _props$mediaSize === void 0 ? 'large' : _props$mediaSize,
    mediaUrl = props.mediaUrl,
    _props$type = props.type,
    type = _props$type === void 0 ? 'wide' : _props$type;
  var mediaClasses = _formatClassName([className, 'card-media', "card-media-".concat(type), "card-media-".concat(mediaSize), "card-media-".concat(mediaPosition), "card-media-".concat(mediaBackground), {
    'has-label': hasLabel
  }]);
  var dataAttributes = dataAttribsForEl(context, optionalAttributes);
  return chakra === 'on' ? /*#__PURE__*/React.createElement("div", dataAttributes, mediaContent || mediaUrl && /*#__PURE__*/React.createElement(Layout, {
    borderRadius: mediaSize !== 'full' ? tokens.BorderRadiiLg : 0,
    overflow: "hidden",
    variant: "flex",
    justifyContent: mediaPosition
  }, /*#__PURE__*/React.createElement(Image, {
    path: mediaUrl,
    aspectRatio: mediaAspectRatio
  }))) : /*#__PURE__*/React.createElement("div", _extends({
    className: mediaClasses
  }, dataAttributes), mediaContent || /*#__PURE__*/React.createElement("img", {
    src: mediaUrl,
    alt: "Card Image"
  }));
};
CardMediaBox.displayName = 'CardMediaBox';
export { CardMediaBox };